import { render } from "./FooterCMS.vue?vue&type=template&id=0ac9d7de"
import script from "../js/footer-cms.js?vue&type=script&lang=js"
export * from "../js/footer-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__